import React, { forwardRef } from "react";
import { useSelector } from "react-redux";
import classes from "./Final.module.css";


const Final = forwardRef((props, ref) => {
    const texts = useSelector(state => state.translate.texts);

    return (
        <div className={classes.Final} >
            <h2>{texts.assessmentCreatedSuccessfully}</h2>
        </div>
    )
})
export default Final